import React, { useState } from 'react';

import { ExportFormat } from '../../../../../apis/graphql/types';
import ExportOptions from '../../../../../components/baymax/ExportOptions';
import { BadgeList, BadgeProps, SearchInput } from '../../../../../components/BlueTheme';
import {
  ClockIconWrapper,
  DownloadIconWrapper,
  ExportButton,
  ReportActions,
  ReportDescription,
  ReportFilters,
  ReportHeader,
  ReportInfo,
  ReportInfoAndActions,
  ReportName,
  ScheduleButton,
} from './styled';

type Props = {
  name: string;
  description: string;
  disabled?: boolean;
  badges: BadgeProps[];
  onScheduleClicked?: () => void;
  searchTerm: string;
  onSearch: (searchTerm: string) => void;
  onGenerateReport: (exportFormat: ExportFormat) => Promise<void>;
  loading: boolean;
  exportAsPDFOnly?: boolean;
  searchPlaceholder?: string;
  filterComponent?: React.ReactElement;
};

const ReportTableHeader = ({
  name,
  description,
  disabled = false,
  badges,
  searchTerm,
  onSearch,
  onScheduleClicked,
  onGenerateReport,
  loading,
  exportAsPDFOnly,
  searchPlaceholder,
  filterComponent,
}: Props): JSX.Element => {
  const [isDownloadDropdownOpen, setIsDownloadDropdownOpen] = useState(false);

  const handleDownloadAction = (): void => {
    setIsDownloadDropdownOpen((value) => !value);
  };

  return (
    <ReportHeader>
      <ReportInfoAndActions>
        <ReportInfo>
          <ReportName>{name}</ReportName>
          <ReportDescription>{description}</ReportDescription>
        </ReportInfo>
        <ReportActions>
          <SearchInput onChange={onSearch} initialValue={searchTerm} placeholder={searchPlaceholder} />
          {filterComponent}
          {onScheduleClicked && (
            <ScheduleButton data-testid="scheduleButton" disabled={disabled} onClick={onScheduleClicked}>
              <ClockIconWrapper /> Schedule
            </ScheduleButton>
          )}
          {exportAsPDFOnly ? (
            <ExportButton
              data-testid="exportButton"
              onClick={(): Promise<void> => onGenerateReport(ExportFormat.Pdf)}
              isLoading={loading}
            >
              <DownloadIconWrapper />
              Export As PDF
            </ExportButton>
          ) : (
            <ExportButton data-testid="exportButton" onClick={handleDownloadAction} isLoading={loading}>
              <DownloadIconWrapper /> Export As...
              {isDownloadDropdownOpen && (
                <ExportOptions onClick={onGenerateReport} onClickOutside={handleDownloadAction} />
              )}
            </ExportButton>
          )}
        </ReportActions>
      </ReportInfoAndActions>
      <ReportFilters>
        <BadgeList badges={badges} />
      </ReportFilters>
    </ReportHeader>
  );
};

export default ReportTableHeader;
